import * as React from "react";
import $ from "jquery";
import { IGridViewFilter } from "./IGridViewFilter";
import { RioStringHelpers, RioResources, RioIcon, RioIconButton } from "rio.react.all";
import { TextFilterOption } from "../enums/TextFilterOption";

export class TextFilter implements IGridViewFilter {
    constructor(private callback: () => void, private closeFilter: () => void) {
    }

    inputValue: string = "";
    dropDownValue: TextFilterOption = TextFilterOption.StartsWith;

    validate(value: string | number): boolean {
        if (!this.filterActive()) {
            return true;
        } else if (value == null) {
            return false;
        } else {
            switch (this.dropDownValue) {
                case TextFilterOption.StartsWith:
                    return RioStringHelpers.removeDiacritics(value.toString().toLowerCase()).startsWith(RioStringHelpers.removeDiacritics(this.inputValue.toLowerCase()));
                case TextFilterOption.EndsWith:
                    return RioStringHelpers.removeDiacritics(value.toString().toLowerCase()).endsWith(RioStringHelpers.removeDiacritics(this.inputValue.toLowerCase()));
                case TextFilterOption.Contains:
                    return RioStringHelpers.removeDiacritics(value.toString().toLowerCase()).includes(RioStringHelpers.removeDiacritics(this.inputValue.toLowerCase()));
                default:
                    return true;
            }
        }
    }

    private startEndsWithFilterComponent = React.createRef<TextFilterComponent>();

    render() {
        return <TextFilterComponent
            ref={this.startEndsWithFilterComponent}
            onChange={(inputValue, dropDownValue) => {
                this.inputValue = inputValue;
                this.dropDownValue = dropDownValue;
                this.callback();
            }}
            closeFilter={this.closeFilter}
        />;
    }

    clearFilter() {
        this.startEndsWithFilterComponent.current.clearFilter();
    }

    filterActive(): boolean {
        return !!this.inputValue
    }

}

interface ITextFilterComponentProps {
    onChange: (inputValue: string, dropdownValue: TextFilterOption) => void;
    closeFilter: () => void;
}

interface ITextFilterComponentState {
    inputValue: string;
    dropdownValue: TextFilterOption;
}

class TextFilterComponent extends React.Component<ITextFilterComponentProps, ITextFilterComponentState> {
    constructor(props: Readonly<ITextFilterComponentProps>) {
        super(props);

        this.state = {
            inputValue: "",
            dropdownValue: 0
        };

    }

    private filterWrapperElement = React.createRef<HTMLTableElement>();

    render() {
        return (
            <table ref={this.filterWrapperElement} className="filterWrapper">
                <tbody>
                    <tr className="closeButtonRow">
                        <td></td>
                        <td></td>
                        <td>
                            <RioIconButton resource={RioResources.find("FilterClose")} hideText={true} onClick={() => this.props.closeFilter()} hasPermission={true} />
                        </td>
                    </tr>
                    <tr className="filterInput">
                        <td>
                            <span>{RioResources.find("FilterType").text}:</span>
                        </td>
                        <td>
                            <select onChange={(e) => this.handleDropDownChanged(parseInt(e.currentTarget.value))}>
                                <option value={0}>{RioResources.find("StartsWith").text}</option>
                                <option value={1}>{RioResources.find("EndsWith").text}</option>
                                <option value={2}>{RioResources.find("Contains").text}</option>
                            </select>
                        </td>
                        <td>
                            { /* empty to make sure filter button lines up */}
                        </td>
                    </tr>
                    <tr className="filterInput">
                        <td>
                            <span>{RioResources.find("Text").text}:</span>
                        </td>
                        <td>
                            <input type="text" value={!!this.state.inputValue ? this.state.inputValue : ""} onChange={(e: React.ChangeEvent<HTMLInputElement>) => { this.setState({ inputValue: e.target.value }); this.props.onChange(e.target.value, this.state.dropdownValue); }}></input>
                        </td>
                        <td>
                            <button className="clearFilterButton" onClick={() => { this.setState({ inputValue: "" }); this.props.onChange("", this.state.dropdownValue); }}>
                                <RioIcon resource={RioResources.find("ClearFilterIcon")} />
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }

    componentDidUpdate() {
        this.checkIfOffScreen();
    }

    checkIfOffScreen() {
        if (!!this.filterWrapperElement.current) {
            const filterWindowElement = this.filterWrapperElement.current.parentElement;
            const filterWindowElementPosition = filterWindowElement.getBoundingClientRect();

            const tableRowElement = filterWindowElement.parentElement.parentElement;
            const tableRowElementPosition = tableRowElement.getBoundingClientRect();

            if (filterWindowElementPosition.right > tableRowElementPosition.right) {
                $(filterWindowElement).addClass("right");
            }
        }
    }

    handleDropDownChanged(value: number) {
        let result = isNaN(value) ? TextFilterOption.StartsWith : value
        this.setState({
            dropdownValue: isNaN(value) ? TextFilterOption.StartsWith : value
        });

        this.props.onChange(this.state.inputValue, result)
    }

    clearFilter() {
        this.setState({
            inputValue: ""
        });
        this.props.onChange("", this.state.dropdownValue);
    }
}